import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const RoundTripIcon: FC<IconProps> = ({ width = 24, height = 24, ...rest }) => (
  <Icon type="RoundTrip" width={width} height={height} alt="RoundTripIcon" ignoreRtl {...rest} />
)
